var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTractor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8178 62.3175V66.3M93.8178 66.3V72.5568M93.8178 66.3H84.5989M84.5989 62.2995V66.3M84.5989 66.3V72.5568M84.5989 72.5568V84.8994H93.8178V72.5568M84.5989 72.5568H93.8178",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.914 48.9855C51.1711 49.9284 45.4625 53.0141 44.5711 57.8141",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5706 29.1001H56.0563H95.571V24.9H53.5706V29.1001Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3154 60.8145C97.4007 60.7569 101.881 61.3284 103.115 64.0716C104.35 66.8139 105.515 69.6714 105.944 70.7568H115.372M84.6549 78.9H110.915",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.6 54.9006C104.04 55.2434 105.371 58.9292 105.857 60.729",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.17 54.9006C109.61 55.2434 110.942 58.9292 111.427 60.729",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.829 54.9006C115.269 55.2434 116.6 58.9292 117.086 60.729",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4287 29.0994V51.2137",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.229 47.9572C138.6 54.4715 138.086 51.4715 138.001 58.1573C137.914 64.8429 137.914 68.9568 137.057 69.9855M125.143 60.9855C125.143 58.9287 124.715 55.7102 127.201 56.1001C131.572 56.7858 134.169 56.6144 133.971 61.7568C133.835 65.3226 133.628 66.6141 133.543 66.8139",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7714 95.2501C72.2156 95.2501 81.4928 85.9728 81.4928 74.5287C81.4928 63.0845 72.2156 53.8073 60.7714 53.8073C49.3273 53.8073 40.05 63.0845 40.05 74.5287C40.05 85.9728 49.3273 95.2501 60.7714 95.2501Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.514 95.249C133.934 95.249 139.95 89.2336 139.95 81.8133C139.95 74.393 133.934 68.3777 126.514 68.3777C119.094 68.3777 113.078 74.393 113.078 81.8133C113.078 89.2336 119.094 95.249 126.514 95.249Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8278 29.0994H56.0567L53.9139 48.9851H61.6281C72.2567 48.9851 80.369 54.4319 84.6547 62.3175H93.8187L92.8278 29.0994Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.241 31.4584H96.5592V41.2493H100.241V31.4584Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0737 44.9724H46.7308V49.2581",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8579 85.9936C67.1421 85.9936 72.2364 80.8993 72.2364 74.6151C72.2364 68.3309 67.1421 63.2366 60.8579 63.2366C54.5737 63.2366 49.4794 68.3309 49.4794 74.6151C49.4794 80.8993 54.5737 85.9936 60.8579 85.9936Z",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractor);
export default __webpack_public_path__ + "static/media/tractor.5b42f1d580bc205fee768fd0a60cdb44.svg";
export { ForwardRef as ReactComponent };